import axios from "./Interceptor.js"
let address = window.global_config.BASE_URL2
let templateApi = {
  setTemplate: (info) => {
    return axios({
      method: "post",
      url: `${address}DataParsing/SetParsingTemplate`,
      data: info
    })
  },
  templatePageList: (info) => {
    return axios({
      method: "post",
      url: `${address}DataParsing/GetPageList`,
      data: info
    })
  },
  // delTemplate: (id) => {
  //   return axios({
  //     method: "get",
  //     url: `${address}DataParsing/DeleteParsingRule?RuleId=${id}`,
  //   })
  // },
  delTemplate: (id) => {
    return axios({
      method: "get",
      url: `${address}DataParsing/DeleteParsingTemplate?TemplateId=${id}`,
    })
  },
  getTemplate: (id) => {
    return axios({
      method: "get",
      url: `${address}DataParsing/GetParsingTemplateById?TemplateId=${id}`,
    })
  },
  delRule: (id) => {
    return axios({
      method: "get",
      url: `${address}DataParsing/DeleteParsingRule?RuleId=${id}`,
    })
  },
  zntq: (data) => {
    return axios({
      method: "post",
      url: `${address}DataParsing/TemplatParsingList`,
      data
    })
  },
  zntq: (data) => {
    return axios({
      method: "post",
      url: `${address}DataParsing/ParsingFileData`,
      data
    })
  },
}
export default templateApi